import cx from 'classnames'
import styles from './StatePage.css'

import { Icon } from '@vzmi/shp_shared_compo'

export const NoData = ({ iconType, text = '目前尚無資料，請稍候重試', className, children, onClick, ...restProps }) => {
  const classes = cx(styles.NoData, {
    [styles.clickable]: !!onClick,
    [className]: !!className
  })
  return (
    <div
      className={styles.wrapper}
      data-role='state-noData'
    >
      <div
        className={classes}
        onClick={onClick}
        {...restProps}
      >
        <div style={{ margin: '0 auto' }}>
          <Icon
            name={iconType}
            size={120}
          />
        </div>
        <span>{text}</span>
        {children}
      </div>
    </div>
  )
}

export const Loading = ({ iconType, text, className, children, onClick, ...restProps }) => {
  const classes = cx(styles.Loading, {
    [styles.clickable]: !!onClick,
    [className]: !!className
  })
  return (
    <div
      className={styles.wrapper}
      data-role='state-loading'
    >
      <div
        className={classes}
        onClick={onClick}
        {...restProps}
      >
        <Icon
          name={iconType}
          size={130}
        />
        <span>{text}</span>
        {children}
      </div>
    </div>
  )
}

export const Error = ({ iconType, text, className, children, onClick, ...restProps }) => {
  const classes = cx(styles.Error, {
    [styles.clickable]: !!onClick,
    [className]: !!className
  })
  return (
    <div
      className={styles.wrapper}
      data-role='state-error'
    >
      <div
        className={classes}
        onClick={onClick}
        {...restProps}
      >
        <Icon name={iconType} />
        <span>{text}</span>
        {children}
      </div>
    </div>
  )
}
